<app-header *ngIf="checkRouting()"></app-header>
<router-outlet></router-outlet>